import Vue from 'vue'
import { VueDatePicker } from '@mathieustan/vue-datepicker'

Vue.component('VueDatePicker', VueDatePicker)
